import type { UiLanguageCode } from '../languages';

import { enMessages } from './en-US';
import { esMessages } from './es-419';
import { idMessages } from './id-ID';

export type { Messages } from './en-US';

/**
 * Lookup table from every {@link UiLanguageCode} to its translation bundle.
 * `useTranslation` reads from this to resolve keys; consumers shouldn't need
 * to touch it directly. Register new locales here when adding to
 * `SUPPORTED_UI_LANGUAGES`.
 */
export const ALL_MESSAGES: Record<UiLanguageCode, typeof enMessages> = {
  'en-US': enMessages,
  'id-ID': idMessages,
  'es-419': esMessages,
};
